import React, { memo, useEffect } from 'react';
import styled from 'App/styled';
import { hexToRgb } from '@nykaa/ui-components/styles/utils';
import { Variant } from 'shared/store/product/types';
import ShadePallet from './ShadePallet';


const OOSText = 'Out Of Stock';
interface ShadesProps {
  variants: Variant[];
  currentVariantId: string;
  changeVariant: Function;
  setDisableLazy: React.Dispatch<React.SetStateAction<boolean>>;
  isDisableLazy: boolean;
}
const Wrapper = styled.div`
  display: flex;
`;
const SelectedVariantIcon = styled.div`
  width: 80px;
  height: 80px;
  background-color: ${({ theme }) => hexToRgb(theme.colors.state, 0.72)};
  margin-top: ${({ theme }) => theme.spacing.spacing40};
  margin-right: ${({ theme }) => theme.spacing.spacing120};
  position: relative;

  img {
    width: 100%;
    height: 100%;
    border-radius: ${({ theme }) => theme.borders.radius20};
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    width: 55px;
    height: 55px;
    margin-top: ${({ theme }) => theme.spacing.spacing0};
    margin-right: ${({ theme }) => theme.spacing.spacing60};
    border-radius: ${({ theme }) => theme.borders.radius20};
  }
`;
const OutOfStockText = styled.span`
  ${({ theme }) => theme.typography.subTitleMedium};
  visibility: hidden;
  display: block;
  position: absolute;
  left: 50%;
  white-space: nowrap;
  background: #ccc;
  padding-left: ${({ theme }) => theme.spacing.spacing20};
  padding-right: ${({ theme }) => theme.spacing.spacing20};
  transform: translateX(-50%);
  bottom: -6px;
  &.outofstock {
    visibility: visible;
  }
`;


const Shades = ({
  variants,
  currentVariantId,
  changeVariant,
  setDisableLazy,
  isDisableLazy,
}: ShadesProps) => {
  const selectedElement = variants.find((ele) => ele.childId === currentVariantId);
  const selectedIndex = variants.findIndex(variant => variant.childId === currentVariantId);

  useEffect(() => {
    if ( selectedIndex > 10) {
      setDisableLazy(true);
    }
  }, [selectedIndex, setDisableLazy]);

  return (
    <Wrapper>
      <SelectedVariantIcon>
        <img
          alt="selected icon"
          src={selectedElement?.shadeImage}
        />
        <OutOfStockText
          className={(selectedElement?.inStock) ? '' : 'outofstock'}
        >{OOSText}</OutOfStockText>
      </SelectedVariantIcon>
      <ShadePallet
        variants={variants}
        currentVariantId={currentVariantId}
        changeVariant={changeVariant}
        isDisabledLazy={isDisableLazy}
      />
    </Wrapper>
  );
};


export default memo(Shades);
